import { liftListItem, wrapInList } from '../../../../node_modules/prosemirror-schema-list/dist/index.es.js';
import { d as dist } from '../../../../node_modules/prosemirror-utils/dist/index.js';

function isList(node, schema) {
  return node.type === schema.nodes.bulletList || node.type === schema.nodes.orderedList || node.type === schema.nodes.taskList;
}

function toggleList(listType, itemType) {
  return (state, dispatch, view) => {
    const {
      schema,
      selection
    } = state;
    const {
      $from,
      $to
    } = selection;
    const range = $from.blockRange($to);

    if (!range) {
      return false;
    }

    const parentList = dist.findParentNode(node => isList(node, schema))(selection);

    if (range.depth >= 1 && parentList && range.depth - parentList.depth <= 1) {
      if (parentList.node.type === listType) {
        return liftListItem(itemType)(state, dispatch, view);
      }

      if (isList(parentList.node, schema) && listType.validContent(parentList.node.content)) {
        const {
          tr
        } = state;
        tr.setNodeMarkup(parentList.pos, listType);

        if (dispatch) {
          dispatch(tr);
        }

        return false;
      }
    }

    return wrapInList(listType)(state, dispatch, view);
  };
}

export { toggleList };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/RichTextEditor/custom-extensions/commands/toggleList.js